import { useState, useEffect } from 'react';
import { statusApi } from '@/api/status';
import { useAuth } from '@/context/AuthContext';
import { BottomNav } from '@/components/BottomNav';
import type { RiderProfile } from '@/types';
import { SUPPORT_PHONE } from '@/utils/env';

export function ProfilePage() {
  const { logout } = useAuth();
  const [profile, setProfile] = useState<RiderProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    statusApi
      .getProfile()
      .then((res) => {
        if (res.data) setProfile(res.data.profile);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="loading-center" style={{ minHeight: '100dvh' }}>
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div style={{ paddingBottom: 72 }}>
      <div className="container">
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20, paddingTop: 8 }}>Profile</h1>

        {profile && (
          <div className="card" style={{ marginBottom: 16 }}>
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                background: 'var(--primary)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 28,
                fontWeight: 700,
                margin: '0 auto 16px',
              }}
            >
              {profile.name.charAt(0).toUpperCase()}
            </div>

            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <p style={{ fontSize: 20, fontWeight: 700 }}>{profile.name}</p>
              <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{profile.phone}</p>
              <span
                className={`badge ${profile.isVerified ? 'badge-delivered' : 'badge-created'}`}
                style={{ marginTop: 8 }}
              >
                {profile.isVerified ? 'Verified' : 'Pending Verification'}
              </span>
            </div>

            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
              {[
                { label: 'Vehicle Type', value: profile.vehicleType },
                { label: 'Vehicle Number', value: profile.vehicleNumber },
                { label: 'Status', value: profile.status },
              ].map((item) => (
                <div
                  key={item.label}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '10px 0',
                    fontSize: 14,
                    borderBottom: '1px solid var(--border)',
                  }}
                >
                  <span style={{ color: 'var(--text-secondary)' }}>{item.label}</span>
                  <span style={{ fontWeight: 600 }}>{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <button
          className="btn btn-full"
          style={{
            background: 'var(--success-light)',
            color: '#166534',
            fontWeight: 600,
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
          }}
          onClick={() => {
            window.open(
              `https://wa.me/${SUPPORT_PHONE}?text=${encodeURIComponent('Hi, I need help with my MacroRides rider account.')}`,
              '_blank'
            );
          }}
        >
          💬 Chat with Support
        </button>

        <button
          className="btn btn-danger btn-full"
          onClick={() => {
            logout();
            window.location.href = '/login';
          }}
        >
          Logout
        </button>
      </div>

      <BottomNav />
    </div>
  );
}
